import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class ModalService {
    confirmDelete = new EventEmitter<boolean>();
    sendClientId = new EventEmitter<string>();
    constructor() { }
}